<div
class="container-fluid d-flex flex-row justify-content-center mb-0 mt-md-1 mt-1 pt-md-0 pt-0 pb-3 shadow-lg col-xs-12 col-lg-8"
>
<div class="jumbotron-fluid">
  <div class="head-icon d-flex justify-content-center mt-3 mb-3 pb-0">
      <img
        class="mx-auto mb-0 pb-0"
        src="assets/img/mafuta-logo-2b.svg"
        width="35"
        height="35"
      />
  </div>
  <div class="card-body mt-1 pt-2 mb-2 pb-3 shadow-lg">
    <h3 class="text-info d-flex justify-content-center mt-2 pt-1 mb-3">
      Change PIN
    </h3>
    <form [formGroup]="userForm" (ngSubmit)="changePassword()">

      <div class="form-group text-primary">
        <label for="code" [ngClass]="fval.code.valid ? 'text-info' : ''">Code<i  *ngIf="fval.code.valid" class="material-icons">check_circle</i></label>
         <div class="input-group mb-0">
                         <input id="code" formControlName="code" type="text" class="form-control"  [ngClass]=" { 'is-invalid': (fval.code.touched||fval.code.dirty) && fval.code.errors }" placeholder="Enter the provided code" autocomplete="off"/>
                       </div>
                     <div class="text-danger col" *ngIf="(fval.code.touched||fval.code.dirty)  && fval.code.errors?.required">The code is required!</div>
                     </div>

      <div class="form-group text-primary">
        <label
          for="password"
          [ngClass]="fval.password.valid ? 'text-info' : ''"
          >New PIN<i *ngIf="fval.password.valid" class="material-icons"
            >check_circle</i
          ></label
        >

        <div class="input-group mb-0">
          <div class="input-group-prepend">
            <div class="input-group-text">
              <i
                class="fas fa-lock text-primary mx-auto"
                style="size: 50px;"
              ></i>
            </div>
          </div>
          <input
          [type]="fieldType ? 'text' : 'password'"
          id="password"
          formControlName="password"
            class="form-control"
            [ngClass]="{
              'is-invalid':
                (fval.password.touched || fval.password.dirty) &&
                fval.password.errors
            }"
            placeholder="Enter New PIN"
            autocomplete="off"
          />
          <div class="input-group-append">
            <span class="input-group-text">
              <i
                class="fas"
                [ngClass]="{
                  'fa-eye-slash': !fieldType,
                  'fa-eye': fieldType
                }"
                (click)="toggleFieldType()"
              ></i>
            </span>
          </div>
        </div>
        <div
          class="text-danger col"
          *ngIf="
            (fval.password.touched || fval.password.dirty) &&
            fval.password.errors?.required
          "
        >
          New PIN is required!
        </div>
        <div
        class="col"
        *ngIf="
          (fval.password.touched || fval.password.dirty) &&
          fval.password.invalid
        "
        [ngClass]="
          fval.password.errors?.required ||
          fval.password.errors?.minlength ||
          fval.password.errors?.maxlength
            ? 'text-danger'
            : 'text-info'
        "
      >
        <i class="material-icons">{{
          fval.password.errors?.required ||
          fval.password.errors?.minlength ||
          fval.password.errors?.maxlength
            ? "cancel"
            : "check_circle"
        }}</i>
        PIN should have exactly four digits!
      </div>
      <div
        class="col"
        *ngIf="
          (fval.password.touched || fval.password.dirty) &&
          fval.password.invalid
        "
        [ngClass]="
          fval.password.hasError('required') ||
          fval.password.hasError('hasNumber')
            ? 'text-danger'
            : 'text-info'
        "
      >
        <i class="material-icons">{{
          fval.password.hasError("required") ||
          fval.password.hasError("hasNumber")
            ? "cancel"
            : "check_circle"
        }}</i>
        Only digits are allowed!
      </div>
  </div>
          <div class="form-group text-primary">
            <label
              for="confirmPassword"
              [ngClass]="fval.confirmPassword.valid ? 'text-info' : ''"
              >Confirm PIN<i
                *ngIf="fval.confirmPassword.valid"
                class="material-icons"
                >check_circle</i
              ></label
            >

            <div class="input-group mb-0">
              <div class="input-group-prepend">
                <div class="input-group-text">
                  <i
                    class="fas fa-lock text-primary mx-auto"
                    style="size: 50px"
                  ></i>
                </div>
              </div>
              <input
                id="confirmPassword"
                formControlName="confirmPassword"
                [type]="fieldType ? 'text' : 'password'"
                class="form-control"
                [ngClass]="{
                  'is-invalid':
                    (fval.confirmPassword.touched ||
                      fval.confirmPassword.dirty) &&
                    fval.confirmPassword.errors
                }"
                placeholder="Confirm your PIN"
                autocomplete="off"
              />
              <div class="input-group-append">
                <span class="input-group-text">
                  <i
                    class="fas"
                    [ngClass]="{
                      'fa-eye-slash': !fieldType,
                      'fa-eye': fieldType
                    }"
                    (click)="toggleFieldType()"
                  ></i>
                </span>
              </div>
            </div>

            <div
              class="text-danger col"
              *ngIf="fval.confirmPassword.errors?.NoPasswordMatch"
            >
              PINs do not match!
            </div>
            <div
              class="text-danger col"
              *ngIf="
                fval.confirmPassword.errors?.required &&
                (fval.confirmPassword.touched || fval.confirmPassword.dirty)
              "
            >
              Please confirm your PIN!
            </div>
          </div>
<div class="d-flex my-2 py-2 mx-auto">
  <button
    type="submit"
    class="btn btn-info col-5 mx-auto"
    [disabled]="!userForm.valid"
  >
    Save
  </button>

  <button
    type="button"
    class="btn btn-info col-5 mx-auto"
    routerLink="/authpage/login"
  >
    Cancel
  </button>
  <ngx-spinner class="bg-info" size="medium" type="ball-scale-multiple">
    <p class="text-light">Please wait...</p>
  </ngx-spinner>

  <label class="col" *ngIf="errored" class="text-danger">
    <!-- <i class="material-icons">Cancel</i> -->

    <ngx-alerts></ngx-alerts>
  </label>

  <label class="col" *ngIf="posted" class="text-info">
    <!-- <i class="material-icons">check_circle</i> -->
    <ngx-alerts></ngx-alerts>
  </label>
</div>

    </form>
  </div>
</div>
</div>
<!--footer -->
<div class="d-flex justify-content-center col-xs-12 col-lg-12 mt-3 mx-auto">
  <div class="small text-center text-info">
   &copy; 2020 - ThunderBolt
  </div>
</div>
<!--/ footer -->
